<template>
  <div class="text-container md:md-text-container">
    <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
      <div class="md:col-span-8">
        <Heading text="Helping you visualise your Happy Place"/>
      </div>
      <div class="md:col-span-8">
        Welcome to the Visualogical Arts-Lab.
      </div>
      <div class="md:col-span-8">
        We’re investigating what makes people’s Happy Place.
      </div>
      <div class="md:col-span-8">
        As part of our research, we’re looking for patterns in how ideas of home and happiness
        evolve.
      </div>
      <div class="md:col-span-8">
        Together with an artificial intelligence algorithm, you’re going to create a symbolic
        snapshot, or a Psyche-Selfie, that visualises your Happy Place.
      </div>
      <div class="md:col-span-8">
        Are you free from distraction?
      </div>
      <div class="md:col-span-8">
        <Button v-bind:onClick="begin" text="Let's begin"/>
      </div>
    </div>
    <audio ref="aud" src="@/assets/audio/intro.mp3" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import Heading from '@/components/Heading.vue';

export default {
  name: 'Intro',
  components: {
    Button,
    Heading,
  },
  methods: {
    begin() {
      this.$refs.aud.pause();
      this.$store.commit('setView', 'Questions');
    },
  },
  mounted() {
    this.$refs.aud.play();
  },
};
</script>

<style scoped>
</style>
